export default __webpack_public_path__ + "static/media/ic-play-button.6d94f7f5.svg";